import type { ActionReference } from "@smartsuite/automation-engine-api";

interface WithActionReference {
  actionReference?: ActionReference;
}

export const findMatchedAction = <T extends WithActionReference>(
  actionRef: WithActionReference,
  actions: T[],
): T | undefined =>
  actions.find(
    (action) =>
      actionRef.actionReference?.actionId ===
        action.actionReference?.actionId &&
      actionRef.actionReference?.instanceId ===
        action.actionReference?.instanceId &&
      actionRef.actionReference?.integrationId ===
        action.actionReference?.integrationId,
  );
